import { PropsWithChildren } from 'react'
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar'
import { PlatformSidebar } from '@/components/PlatformSidebar'
import Layout from '@/components/Layout'
import { UserMenu } from '@/components/UserMenu'

function getSidebarDefault(): boolean {
  if (typeof document === 'undefined') return true
  const match = document.cookie.match(/sidebar_state=(\w+)/)
  return match ? match[1] === 'true' : true
}

export default function PlatformLayout({ children }: PropsWithChildren) {
  return (
    <Layout>
      <SidebarProvider defaultOpen={getSidebarDefault()}>
        <PlatformSidebar />
        <main className="flex-1 w-full overflow-x-hidden">
          <div className="bg-bewave-header border-b shadow-sm">
            <div className="flex h-14 items-center gap-4 px-4">
              <SidebarTrigger />
              <span className="text-sm font-medium text-foreground">Plataforma Bee Wave</span>
              <div className="flex-1" />
              <div className="ml-auto flex items-center gap-2">
                <UserMenu />
              </div>
            </div>
          </div>
          <div className="overflow-x-hidden">
            {children}
          </div>
        </main>
      </SidebarProvider>
    </Layout>
  )
}
